import React from 'react';

import FlexBox from 'Elements/FlexBox';

import SearchResultCard, { SearchResultCardProps } from 'Components/Card/SearchResult';
import Pagination, { PaginationProps } from 'Components/Pagination';

import { List, ListItem } from './Search.styled';

export interface Props {
    results: SearchResultCardProps[];
    resultsCountText?: string;
    pagination: PaginationProps;
}

const Search: React.FC<Props> = props => {
    const { results, resultsCountText, pagination } = props;

    return (
        <div>
            {results.length > 0 ? (
                <>
                    <p>{resultsCountText}</p>
                    <List>
                        {results.map((item, index) => (
                            <ListItem key={index}>
                                <SearchResultCard {...item} />
                            </ListItem>
                        ))}
                    </List>
                    <FlexBox justifyContent="center">
                        <Pagination {...pagination} />
                    </FlexBox>
                </>
            ) : (
                <FlexBox justifyContent="center">
                    <p>Sorry, your query returned no results 😔</p>
                </FlexBox>
            )}
        </div>
    );
};

export default Search;
